import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { DEFAULT_LAYOUT_NAVIGATION } from './default-layout-navigation.config';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-default-layout-navigation',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './default-layout-navigation.component.html',
  styleUrl: './default-layout-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultLayoutNavigationComponent {
  private translocoService = inject(TranslocoService);
  private router = inject(Router);

  private expandedGroups = signal<Set<string>>(new Set());

  items = computed(() => {
    // Trigger reactivity on language change
    this.translocoService.langChanges$;

    return this.translateItems(DEFAULT_LAYOUT_NAVIGATION);
  });

  private translateItems(items: MenuItem[]): MenuItem[] {
    return items.map(item => ({
      ...item,
      label: this.translocoService.translate(item.label!),
      items: item.items ? this.translateItems(item.items as MenuItem[]) : undefined,
    }));
  }

  toggleGroup(item: MenuItem): void {
    const label = item.label!;
    const expanded = this.expandedGroups();
    const newExpanded = new Set(expanded);

    if (newExpanded.has(label)) {
      newExpanded.delete(label);
    } else {
      newExpanded.add(label);
    }

    this.expandedGroups.set(newExpanded);
  }

  isGroupExpanded(item: MenuItem): boolean {
    return this.expandedGroups().has(item.label!);
  }

  isGroupActive(item: MenuItem): boolean {
    if (!item.items) return false;

    const currentUrl = this.router.url;
    return item.items.some((subItem: MenuItem) =>
      subItem.routerLink && currentUrl.startsWith(subItem.routerLink as string)
    );
  }
}
